import { FC } from 'react';
import { CreateButton, EditButton, FunctionField, SearchInput, TextField, TopToolbar, WrapperField } from 'react-admin';

import CraftList from 'src/components/CraftList';
import AuditBasedStatusFilterInput from 'src/inputs/AuditBasedStatusFilterInput';
import ClearFiltersButton from 'src/components/ClearFiltersButton';
import BulkSoftDeleteButton from 'src/components/BulkSoftDeleteButton';
import { usePermissions } from 'src/hooks';
import { ApiFieldRecord } from 'src/types';

const columnStyles = {
  actions: {
    width: '12rem',
    '& :nth-child(n + 2)': {
      ml: 0.5,
    },
  },
};

const filters = [
  <SearchInput key="search" source="path" placeholder="Search" alwaysOn />,
  <AuditBasedStatusFilterInput key="statusFilter" source="deleted_at@_is_null" inactiveLabel="Deleted" alwaysOn />,
];

const ListActions = ({ canCreate }: { canCreate: boolean }) => (
  <TopToolbar>
    <ClearFiltersButton />
    {canCreate && <CreateButton />}
  </TopToolbar>
);

export const ApiFieldsList: FC = () => {
  const { permissions } = usePermissions();

  const canCreate = permissions.has('apiField:edit');
  const canEdit = permissions.has('apiField:edit');
  const canDelete = permissions.has('apiField:delete');

  const bulkActionButtons = canDelete && (
    <BulkSoftDeleteButton
      label="Delete Selected"
      dialogTitle="Delete API Fields (%{smart_count})"
      dialogContent="Are you sure you want to delete these items?"
      data={{ deleted_at: 'now()' }}
    />
  );

  return (
    <CraftList
      title="API Fields"
      filters={filters}
      filterDefaultValues={{ 'deleted_at@_is_null': true }}
      actions={<ListActions canCreate={canCreate} />}
      showClearButton={false}
      sort={{ field: 'path', order: 'ASC' }}
      dataGridProps={{ bulkActionButtons }}
      columnStyles={columnStyles}
    >
      <TextField source="id" />
      <TextField source="path" />
      <WrapperField label="Actions" headerClassName="column-actions" cellClassName="column-actions">
        {canEdit && <FunctionField render={(rec: ApiFieldRecord) => <EditButton disabled={!!rec.deleted_at} />} />}
      </WrapperField>
    </CraftList>
  );
};

export default ApiFieldsList;
